import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import ScreenSaverView from "../views/ScreenSaverView.vue";
import IFrameView from "../views/IFrameView.vue";

const routes = [
  {
    path: "/:lang(fr|de)?",
    children: [
      {
        path: "",
        name: "screensaver",
        component: ScreenSaverView,
      },
      {
        path: "home",
        name: "home",
        component: HomeView,
        props: (route) => ({
          buttons: getButtons(route.params.lang || "fr", "home"),
        }),
      },
      {
        path: "formations",
        name: "formations",
        component: HomeView,
        props: (route) => ({
          buttons: getButtons(route.params.lang || "fr", "formations"),
        }),
      },
      {
        path: "site",
        name: "site",
        component: IFrameView,
        props: (route) => ({ iframeUrl: route.query.url }),
      },
    ],
  },
];

const buttonsConfig = {
  fr: {
    home: [
      {
        text: "50 ans de la formation en travail social",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/hautes-ecoles/haute-ecole-de-travail-social/50-ans-de-la-formation-en-travail-social-en-valais-210102",
          },
        },
      },
      {
        text: "Formations",
        route: { name: "formations" },
      },
      {
        text: "Le travail social, est-ce pour toi ?",
        route: {
          name: "site",
          query: {
            url: "https://quiz.hevs.ch/social-work-hevs-french/interested-study",
          },
        },
      },
      {
        text: "Institut Travail Social (ITS)",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/recherche-appliquee-et-developpement-a-la-hes-so-valais-wallis/institut-travail-social-valais/",
          },
        },
      },
      {
        text: "Séances d'info",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/hes-so-valais-wallis/seances-d-information/",
          },
        },
      },
      {
        text: "Campus Pôle Santé",
        route: { name: "site", query: { url: "https://www.youtube.com/embed/30WODplFBfc?rel=0&hl=fr" } },
      },
    ],
    formations: [
      {
        text: "Bachelor en Travail Social",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/hautes-ecoles/haute-ecole-de-travail-social/formation-bachelor-en-travail-social/",
          },
        },
      },
      {
        text: "ES Maîtrise socioprofessionnelle",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/formations/diplomes-es/maitrise-socioprofessionnelle/",
          },
        },
      },
      {
        text: "ES Eduction de l'enfance",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/formations/diplomes-es/education-de-l-enfance/",
          },
        },
      },
      {
        text: "Formation continue",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/hautes-ecoles/haute-ecole-de-travail-social/formation-continue-travail-social-200236",
          },
        },
      },
    ],
  },

  de: {
    home: [
      {
        text: "50 Jahre Ausbildung in Sozialer Arbeit im Wallis",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/Hochschule/hochschule-fur-soziale-arbeit/50-jahre-ausbildung-in-sozialer-arbeit-im-wallis-210102",
          },
        },
      },
      {
        text: "Ausbildung",
        route: { name: "formations" },
      },
      {
        text: " Ist Soziale Arbeit etwas für dich?",
        route: {
          name: "site",
          query: {
            url: "https://quiz.hevs.ch/social-work-hevs-german/interested-study",
          },
        },
      },
      {
        text: "Institut für Soziale Arbeit (ITS)",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/anwendungsorientierte-forschung-entwicklung/das-institut-soziale-arbeit-der-fachhochschule-wallis/",
          },
        },
      },
      {
        text: "Informations-veranstaltungen",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/fachhochschule-wallis/informationsveranstaltungen/",
          },
        },
      },
      {
        text: "Gesundheitscampus",
        route: { name: "site", query: { url: "https://www.youtube.com/embed/xFi8tjDtz1E?rel=0&hl=de" } },
      },
    ],
    formations: [
      {
        text: "Bachelorausbildung in Sozialer Arbeit",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/Hochschule/hochschule-fur-soziale-arbeit/bachelorausbildung-in-sozialer-arbeit/",
          },
        },
      },
      {
        text: "Weiterbildung",
        route: {
          name: "site",
          query: {
            url: "http://hevs.ch/de/Hochschule/hochschule-fur-soziale-arbeit/weiterbildung-soziale-arbeit-200236",
          },
        },
      },
    ],
  },
};

function getButtons(lang = "fr", section = "home") {
  return buttonsConfig[lang]?.[section] || buttonsConfig["fr"][section];
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
